(function () {
  'use strict';

  /* ============================================================
     RSI WE BUY RACKING — Page-scoped JS
     1. Before/after switcher
     2. Media uploader previews and removal
     3. Form submission (webhook or Shopify contact fallback)
  ============================================================ */

  // ---- 1. Before/after switcher ----
  document.querySelectorAll('[data-rsi-we-buy-switcher]').forEach(function (wrap) {
    var tabs   = wrap.querySelectorAll('[data-rsi-we-buy-view]');
    var panels = wrap.querySelectorAll('[data-rsi-we-buy-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-rsi-we-buy-view');

        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        panels.forEach(function (p) {
          if (p.getAttribute('data-rsi-we-buy-panel') === target) {
            p.classList.add('is-active');
          } else {
            p.classList.remove('is-active');
          }
        });
      });
    });
  });

  // ---- 2. Media uploader ----
  document.querySelectorAll('[data-rsi-upload]').forEach(function (uploadRoot) {
    var input = uploadRoot.querySelector('input[type="file"]');
    var preview = uploadRoot.querySelector('[data-rsi-upload-preview]');
    if (!input || !preview) return;

    var selectedFiles = [];
    var objectUrls = [];

    uploadRoot.addEventListener('dragover', function (e) {
      e.preventDefault();
      uploadRoot.classList.add('is-drag-over');
    });

    uploadRoot.addEventListener('dragleave', function (e) {
      if (!uploadRoot.contains(e.relatedTarget)) {
        uploadRoot.classList.remove('is-drag-over');
      }
    });

    uploadRoot.addEventListener('drop', function (e) {
      e.preventDefault();
      uploadRoot.classList.remove('is-drag-over');
      if (e.dataTransfer && e.dataTransfer.files.length) {
        addFiles(e.dataTransfer.files);
      }
    });

    input.addEventListener('change', function () {
      addFiles(input.files);
    });

    function addFiles(files) {
      var existing = {};
      selectedFiles.forEach(function (file) {
        existing[fileKey(file)] = true;
      });

      Array.from(files || []).forEach(function (file) {
        var key = fileKey(file);
        if (!existing[key]) {
          selectedFiles.push(file);
          existing[key] = true;
        }
      });

      syncInputFiles();
      renderPreview();
    }

    function syncInputFiles() {
      if (typeof DataTransfer === 'undefined') return;

      var dataTransfer = new DataTransfer();
      selectedFiles.forEach(function (file) {
        dataTransfer.items.add(file);
      });

      input.files = dataTransfer.files;
    }

    function renderPreview() {
      revokeObjectUrls();
      preview.innerHTML = '';

      selectedFiles.forEach(function (file, index) {
        var card = document.createElement('div');
        card.className = 'rsi-we-buy-upload-preview__item';

        if (isPreviewableImage(file)) {
          var img = document.createElement('img');
          var objectUrl = URL.createObjectURL(file);
          objectUrls.push(objectUrl);
          img.src = objectUrl;
          img.alt = file.name;
          card.appendChild(img);
        } else {
          var fileIcon = document.createElement('div');
          fileIcon.className = 'rsi-we-buy-upload-preview__file';
          fileIcon.textContent = fileLabel(file);
          card.appendChild(fileIcon);
        }

        var body = document.createElement('div');
        body.className = 'rsi-we-buy-upload-preview__body';

        var name = document.createElement('span');
        name.className = 'rsi-we-buy-upload-preview__name';
        name.textContent = file.name;

        var size = document.createElement('span');
        size.className = 'rsi-we-buy-upload-preview__size';
        size.textContent = formatFileSize(file.size);

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'rsi-we-buy-upload-preview__remove';
        remove.textContent = 'Remove';
        remove.addEventListener('click', function () {
          selectedFiles.splice(index, 1);
          syncInputFiles();
          renderPreview();
        });

        body.appendChild(name);
        body.appendChild(size);
        card.appendChild(body);
        card.appendChild(remove);
        preview.appendChild(card);
      });

      uploadRoot.classList.toggle('has-files', selectedFiles.length > 0);
    }

    function revokeObjectUrls() {
      objectUrls.forEach(function (url) {
        URL.revokeObjectURL(url);
      });
      objectUrls = [];
    }

    function fileKey(file) {
      return [file.name, file.size, file.lastModified, file.type].join('|');
    }

    function fileLabel(file) {
      var parts = file.name.split('.');
      var extension = parts.length > 1 ? parts.pop().toUpperCase() : 'FILE';
      return extension.length <= 4 ? extension : 'FILE';
    }

    function isPreviewableImage(file) {
      if (!file.type || file.type.indexOf('image/') !== 0) return false;
      return !/\.(heic|heif)$/i.test(file.name);
    }

    function formatFileSize(bytes) {
      if (!bytes && bytes !== 0) return '';
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1048576) return Math.round(bytes / 1024) + ' KB';
      return (bytes / 1048576).toFixed(1) + ' MB';
    }
  });

  // ---- 3. Form handlers (top + main — both use [data-rsi-we-buy-form]) ----
  var shopifySuccess = new URLSearchParams(window.location.search).get('contact[success]') === 'true';

  document.querySelectorAll('[data-rsi-we-buy-form]').forEach(function (form) {
    var webhookUrl   = (form.getAttribute('data-rsi-webhook')  || '').trim();
    var whatsappUrl  = (form.getAttribute('data-rsi-whatsapp') || 'https://wa.me/447380310993').trim();
    var elSuccess    = document.getElementById(form.getAttribute('data-rsi-success')  || '');
    var elError      = document.getElementById(form.getAttribute('data-rsi-error')    || '');
    var elFallback   = document.getElementById(form.getAttribute('data-rsi-fallback') || '');
    var elSubmit     = form.querySelector('[data-rsi-submit]');
    var origBtnText  = elSubmit ? elSubmit.textContent : '';

    // Show honest fallback note when no webhook is configured
    if (!webhookUrl && elFallback) {
      elFallback.style.display = 'block';
    }

    // Handle Shopify contact redirect (contact[success]=true in URL)
    if (shopifySuccess) {
      form.style.display = 'none';
      if (elSuccess) {
        elSuccess.innerHTML = 'Your details have been received. Please <a href="' + whatsappUrl + '" target="_blank" rel="noopener noreferrer">send your photos via WhatsApp</a> so we can prepare your quote.';
        elSuccess.style.display = 'block';
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // Consent checkbox (mid-page form only)
      var consent = form.querySelector('[name="consent"]');
      if (consent && !consent.checked) {
        showErr('Please confirm your consent before submitting.');
        return;
      }

      hideErr();

      if (!webhookUrl) {
        // No webhook — native Shopify contact POST
        // form.submit() does not fire the submit event, so no infinite loop
        form.submit();
        return;
      }

      // Webhook configured — AJAX FormData POST (includes files)
      if (elSubmit) { elSubmit.disabled = true; elSubmit.textContent = 'Sending…'; }

      fetch(webhookUrl, { method: 'POST', body: new FormData(form) })
        .then(function (res) {
          if (res.ok) {
            form.style.display = 'none';
            if (elSuccess) {
              elSuccess.innerHTML = 'Your details and photos have been received. We\'ll be in touch with your quote soon.';
              elSuccess.style.display = 'block';
            }
          } else {
            throw new Error('HTTP ' + res.status);
          }
        })
        .catch(function (err) {
          console.warn('[RSI We Buy Racking] Submission error:', err);
          showErr('Something went wrong. Please <a href="' + whatsappUrl + '" target="_blank" rel="noopener noreferrer">send photos via WhatsApp</a> or call 01827 213073.');
          if (elSubmit) { elSubmit.disabled = false; elSubmit.textContent = origBtnText; }
        });
    });

    function showErr(msg) {
      if (!elError) return;
      elError.innerHTML = msg;
      elError.style.display = 'block';
      elError.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function hideErr() {
      if (elError) elError.style.display = 'none';
    }
  });

})();
